import { render, staticRenderFns } from "./recordNotesDetailModal.vue?vue&type=template&id=1035636f&scoped=true"
import script from "./recordNotesDetailModal.vue?vue&type=script&lang=js"
export * from "./recordNotesDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1035636f",
  null
  
)

export default component.exports